import { defineComponent as r, ref as i, openBlock as s, createBlock as c, resolveDynamicComponent as m, withCtx as f, renderSlot as p } from "vue";
import { useDynamicScrollerItem as d } from "./composables/useDynamicScrollerItem.js";
const B = /* @__PURE__ */ r({
  __name: "DynamicScrollerItem",
  props: {
    item: {},
    watchData: { type: Boolean, default: !1 },
    active: { type: Boolean },
    index: { default: void 0 },
    sizeDependencies: { default: null },
    emitResize: { type: Boolean, default: !1 },
    enabled: { type: Boolean, default: !0 },
    tag: { default: "div" }
  },
  emits: ["resize"],
  setup(a, { emit: l }) {
    const t = a, n = l, o = i();
    return d(
      t,
      o,
      {
        onResize: (e) => n("resize", e)
      }
    ), (e, u) => (s(), c(m(t.tag), {
      ref_key: "el",
      ref: o
    }, {
      default: f(() => [
        p(e.$slots, "default")
      ]),
      _: 3
    }, 512));
  }
});
export {
  B as _
};
//# sourceMappingURL=DynamicScrollerItem.vue_vue_type_script_setup_true_lang-qh6MY0wl.js.map
